export default [
  {
    key: 'videoLink',
    label: 'field.videoEmbedLink',
    rules: 'required',
    type: 'text',
    cols: 12,
  },
  {
    key: 'videoSpLink',
    label: 'field.videoEmbedSpecialLink',
    rules: '',
    type: 'text',
    cols: 12,
  },
]
